/**
 * Tiny relative-time formatter — no library dep.
 *
 * Returns a short human-readable string like "just now", "5 min ago",
 * "3 hours ago", "2 days ago". Falls back to an ISO date past 30 days
 * so the string doesn't stretch to "347 days ago" (which is more
 * confusing than an actual date).
 */
export function formatRelativeTime(isoOrTs, now = Date.now()) {
  if (!isoOrTs) return null;
  const then = typeof isoOrTs === 'string' ? Date.parse(isoOrTs) : Number(isoOrTs);
  if (!Number.isFinite(then)) return null;
  const diffMs = Math.max(0, now - then);
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 45) return 'just now';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? '' : 's'} ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 30) return `${diffDay} day${diffDay === 1 ? '' : 's'} ago`;
  // Past 30 days: show the date (unusual for a live draft but harmless).
  const d = new Date(then);
  return d.toLocaleDateString();
}
